import type { ThemeTypes } from '@/types/themeTypes/ThemeType';

const LightTheme: ThemeTypes = {
  name: 'Light',
  dark: false,
  variables: {
    'border-color': '#1e88e5'
  },
  colors: {
    primary: '#16595a',
    secondary: '#c77e23',
    info: '#03c9d7',
    success: '#00c853',
    accent: '#FFAB91',
    warning: '#ffc107',
    error: '#f44336',
    lightprimary: '#e3ebeb',
    lightsecondary: '#f8f0e5',
    lightsuccess: '#b9f6ca',
    lighterror: '#ef9a9a',
    lightwarning: '#fff8e1',
    darkprimary: '#135152',
    darksecondary: '#c1761f',
    darkText: '#212121',
    lightText: '#616161',
    borderLight: '#90caf9',
    inputBorder: '#787878',
    containerBg: '#e3ebeb',
    surface: '#fff',
    'on-surface-variant': '#fff',
    facebook: '#4267b2',
    twitter: '#1da1f2',
    linkedin: '#0e76a8',
    gray100: '#fafafa',
    primary200: '#8bacad',
    secondary200: '#e3bf91'
  }
};

export { LightTheme };
